import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import type { NFTSearchResult } from "@/components/header/header-search/HeaderSearchModalItem";
import { AnimatePresence, motion } from "framer-motion";
import GroupCreateNftSearchItemsContent from "./GroupCreateNftSearchItemsContent";
import type { ApiGroupOwnsNft } from "@/generated/models/ApiGroupOwnsNft";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function GroupCreateNftSearchItems(t0) {
  const $ = _c(15);
  const {
    open,
    searchCriteria,
    selected,
    onSelect
  } = t0;
  let t1;
  let t2;
  if ($[0] !== searchCriteria) {
    t1 = [QueryKey.NFTS_SEARCH, searchCriteria];
    t2 = async () => await commonApiFetch({
      endpoint: "nfts_search",
      params: {
        search: searchCriteria ?? ""
      }
    });
    $[0] = searchCriteria;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!(searchCriteria && searchCriteria.length >= 3) || !!(searchCriteria && searchCriteria.length > 0 && !isNaN(Number(searchCriteria)));
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    isFetching,
    data: nfts
  } = useQuery(t4);
  let t5;
  if ($[7] !== isFetching || $[8] !== nfts || $[9] !== onSelect || $[10] !== open || $[11] !== selected) {
    t5 = open && <motion.div className="tw-absolute tw-z-20 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-20 tw-mt-1 tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-gap-y-1 tw-px-2 tw-mx-0 tw-mb-0 tw-list-none"><GroupCreateNftSearchItemsContent loading={isFetching} items={nfts ?? []} selected={selected} onSelect={onSelect} /></ul></div></div></motion.div>;
    $[7] = isFetching;
    $[8] = nfts;
    $[9] = onSelect;
    $[10] = open;
    $[11] = selected;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <AnimatePresence mode="wait" initial={false}>{t5}</AnimatePresence>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}